<template>
  <div class="date-time-input clearfix">
    <div class="form-group row">
      <label :class="options.fullWidth ? 'col-sm-12' : 'col-sm-3 col-form-label'">
        Date {{ pickerOptions.label }}
        <span v-if="pickerOptions.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-9'">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">
              <span class="fa fa-fw fa-calendar"></span>
            </span>
          </div>
          <input ref="datepicker" class="form-control" type="text"/>
        </div>
      </div>
    </div>
    <div class="form-group row">
      <label :class="options.fullWidth ? 'col-sm-12' : 'col-sm-3 col-form-label'">
        Time {{ pickerOptions.label }}
        <span v-if="pickerOptions.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-9'">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">
              <span class="far fa-fw fa-clock"></span>
            </span>
          </div>
          <input class="form-control" type="time"
            :class="formControlValidationClass"
            :id="options.name"
            :value="time"
            @input="validateTime($event.target.value)"/>
        </div>
      </div>
    </div>
    <input type="hidden" :name="pickerOptions.name" :value="value"/>
  </div>
</template>

<script>
import {
    validationClass,
    formControlValidationClass,
    validationMessage
  } from '@/util/helpers'

export default {
  name: 'DateTimeInput',
  props: {
    value: {
      type: String
    },
    options: {
      type: Object,
      default () {
        return {
          name: '',
          label: ''
        }
      }
    }
  },
  computed: {
    validationClass,
    formControlValidationClass,
    validationMessage,
    pickerOptions () {
      return {
        format: 'DD/MM/YYYY',
        minDate: null,
        maxDate: null,
        ...this.options
      }
    },
    time () {
      return moment(this.value).format('HH:mm')
    }
  },
  data () {
    return {
      picker: null,
      date: null,
      isValid: true,
      isDirty: false
    }
  },
  mounted () {
    let parent = this
    let inModal = false
    while (parent) {
      parent = parent.$parent
      if (parent && parent.$options._componentTag) {
        inModal = parent.$options._componentTag.includes('modal')
        if (inModal) parent = false
      }
    }
    let theme = inModal ? 'in-modal-theme' : false
    if (this.value !== 'Invalid date') this.date = moment(this.value).isValid() ? moment(this.value).format() : null
    this.picker = new Pikaday({
      field: this.$refs.datepicker,
      format: this.pickerOptions.format,
      defaultDate: moment(this.date).toDate(),
      setDefaultDate: true,
      minDate: moment(this.pickerOptions.minDate).toDate(),
      maxDate: moment(this.pickerOptions.maxDate).toDate(),
      theme,
      onSelect: (date) => {
        this.validateDate(date)
      }
    })
  },
  methods: {
    validateTime (value) {
      let date = moment(this.value)
      if (!date.isValid()) date = moment()
      let hour = moment(value, 'HH:mm').hour()
      let minute = moment(value, 'HH:mm').minute()
      let val = date.set({
        hour, minute
      }).format()
      this.validate(val)
    },
    validateDate (value) {
      let date = moment(this.value)
      if (!date.isValid()) date = moment()
      let hour = moment(date).hour()
      let minute = moment(date).minute()
      let val = moment(value).set({
        hour, minute
      }).format()
      this.validate(val)
    },
    validate (value) {
      this.$emit('input', value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/DateTimeInput.vue